import { api } from './../../api.js';
import { config } from './../../config.js';

const state = {
    carrito: null,
    carritoItems: [],
    aviso: false,
    timer: null 
}

const getters = {
    getCarritoActivo: state => state.carrito,
    getCarritoItems: state => state.carritoItems,
    getSecondsLeft: state => (state.carrito ? state.carrito.seconds_left : null),
}

const mutations = {
    setCarritoActivo(state, carrito) {
        state.carrito = carrito;
    },
    setCarritoItems(state, items) {
        state.carritoItems = items;
    },
    setAviso(state, aviso) {
        state.aviso = aviso;
    },
    decrementSecondsLeft(state) {
        if (state.carrito && state.carrito.seconds_left > 0) {
            state.carrito.seconds_left -= 1;
        }
    },
    clearTimer(state) {
        if (state.timer) {
            clearInterval(state.timer);
            state.timer = null;
        }
    }
}

const actions = {
    TAQUILLA_CARRITO_CREAR({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.crear'), data).then(res => {
                commit('setCarritoActivo', res.data.data);
                resolve(res);
                dispatch('START_CART_TIMER');
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_ACTIVO({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.activo'), data).then(res => {
                const carrito = res.data.data;

                commit('setCarritoActivo', carrito);

                if (carrito) {
                    const params = { cart_id: carrito.id };
                    this.dispatch('TAQUILLA_CARRITO_ITEMS', params).then(itemsRes => {
                        commit('setCarritoItems', itemsRes.data);
                        resolve(res);
                        dispatch('START_CART_TIMER'); 
                    });
                }
            }).catch(error => {
                commit('setCarritoActivo', null);
                commit('setCarritoItems', []);
                console.log(error);
                reject(error);
            });
        });
    },
    START_CART_TIMER({ commit, state, dispatch }) {
        commit('clearTimer'); 
        const timer = setInterval(() => {
            if (state.carrito && state.carrito.seconds_left > 0) {
                commit('decrementSecondsLeft');
            } else if(state.carrito) {
                dispatch('TAQUILLA_CARRITO_ELIMINAR', { cart_id: state.carrito.id })
                commit('clearTimer');
            }
        }, 1000);

        state.timer = timer;
    },
    TAQUILLA_CARRITO_ITEMS({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.items'), data).then(res => {
                commit('setCarritoItems', res.data);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_ADD_ITEMS({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.add-items'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_DELETE_ITEMS({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.delete-items'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_GUARDAR_DATOS({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.guardar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_PROCESAR({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.procesar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TAQUILLA_CARRITO_ELIMINAR({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('taquilla.carrito.eliminar'),data).then(res => {
                commit('setCarritoActivo', null);
                commit('setCarritoItems', []);
                commit('clearTimer');
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    AVISO_CARRITO({ commit }, valor) {
        commit('setAviso', valor);
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};

